<form #datePicker [formGroup]="formGroup" autocomplete="off" class="date-filter gap-5">
  <mat-form-field color="accent">
    <mat-label>Type</mat-label>
    <mat-select required formControlName="dateType">
      <mat-option value="any">Any Date</mat-option>
      <mat-option value="startDate">Start Date</mat-option>
      <mat-option value="endDate">End Date</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field color="accent">
    <mat-label>Choose a date</mat-label>
    <mat-date-range-input [rangePicker]="picker">
      <input matStartDate placeholder="Start date" formControlName="startDate" />
      <input matEndDate placeholder="End date" formControlName="endDate" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>
  </mat-form-field>
</form>
